'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = pollFunctionWithExponentialBackoff;

var _makeExponentialDelayGenerator = require('conversations-lib/time/makeExponentialDelayGenerator');

var _makeExponentialDelayGenerator2 = _interopRequireDefault(_makeExponentialDelayGenerator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var delayGenerator = (0, _makeExponentialDelayGenerator2.default)({ basis: 1000 });

function pollFunctionWithExponentialBackoff(_ref) {
  var fn = _ref.fn,
      limit = _ref.limit;

  var callCount = 0;

  function performPoll() {
    fn();
    callCount++;
    if (callCount < limit) {
      setTimeout(performPoll, delayGenerator(callCount));
    }
  }

  performPoll();
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-lib/static-1.28/js/functions/pollFunctionWithExponentialBackoff.js
// module id = 199
// module chunks = 0 1